
import Vue from "vue"
import type { IList, IMenuTree } from "blog";
import { listToTree } from "./index";




export default Vue.extend({
	name: 'BlogMenu',
	data() {
		return {
			hidenClass: 'hiddenMenu'
		}
	},
	props: {
		list: {
			default: () => [] as IList[]
		}
	},
	methods: {
		hidenMenu(payload: MouseEvent) {

			const target = payload.target as HTMLElement

			const children = target.nextElementSibling
			if (children) {
				if (children.classList.contains(this.hidenClass)) {
					children.classList.remove(this.hidenClass)
				} else {
					children.classList.add(this.hidenClass)
				}
			}

		}
	},

	computed: {
		listTree(): IMenuTree[] {
			return listToTree<IList, IMenuTree>(this.list)
		},
		routeInfo(): Record<'id', number> {
			const { id = -1 } = this.$route.params
			return { id: +id }
		}
	},
	// watch: {
	// 	list() {
	// 		console.log(this.list);

	// 	}
	// }

})
